import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";
import { firstValueFrom } from "rxjs";

import type {
  LocalIndexSearchOptions,
  Service,
} from "@mirage/service-extension-tab-ingestion/service";
import { expectExtensionLocalSearch } from "@mirage/shared/util/webExtensionsHelpers";

const service = services.get<Service>(ServiceId.EXTENSION_TAB_INGESTION);

export function getTabInfos() {
  return firstValueFrom(service.getTabInfos());
}

export function ingestTab(tabId: number) {
  return firstValueFrom(service.ingestTab(tabId));
}

export function searchLocalIndex(
  query: string,
  opts?: LocalIndexSearchOptions,
) {
  if (!expectExtensionLocalSearch()) return Promise.resolve([]);
  return firstValueFrom(service.searchLocalIndex(query, opts));
}

export function getTabContentFromLocalIndex(contentId: string) {
  if (!expectExtensionLocalSearch()) return Promise.resolve(undefined);
  return firstValueFrom(service.getTabContentFromLocalIndex(contentId));
}

export function getSuggestedStacks() {
  if (!expectExtensionLocalSearch()) return Promise.resolve([]);
  return firstValueFrom(service.getSuggestedStacks());
}

export function disableStackSuggestions() {
  if (!expectExtensionLocalSearch()) return;
  return firstValueFrom(service.disableStackSuggestions());
}
